import { defineComponent as l, openBlock as o, createBlock as m, unref as r, mergeProps as p, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const d = /* @__PURE__ */ l({
  name: "IconBankOut",
  __name: "IconBankOut",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (u, e) => (o(), m(r(v), p(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "m18.75 20-.004.077a.75.75 0 0 1-1.492 0L17.25 20v-3a.75.75 0 0 1 1.5 0v3m0-6-.004.077a.75.75 0 0 1-1.492 0L17.25 14v-1.5a.75.75 0 0 1 1.5 0V14" }, null, -1),
        a("path", { d: "M20.6 19.05a.75.75 0 0 1-.091 1L20.45 20.1l-1.7 1.275a1.25 1.25 0 0 1-1.5 0l-1.7-1.275a.75.75 0 0 1 .9-1.2L18 20.062l1.55-1.162.063-.043A.75.75 0 0 1 20.6 19.05m-10.1.2.077.004a.75.75 0 0 1 0 1.492L10.5 20.75H4a.75.75 0 0 1 0-1.5h6.5m.818-16.665a1.25 1.25 0 0 1 1.362 0l.087.061 7.543 5.868c.939.73.423 2.236-.767 2.236H4.457c-1.19 0-1.706-1.506-.768-2.236l7.543-5.868.086-.061M5.186 9.25h13.628l-6.815-5.3-6.813 5.3M5.25 17.5v-5a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-1.5 0m4 0v-5a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-1.5 0m4-1v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-1.5 0" }, null, -1),
        a("path", { d: "M11.318 2.585a1.25 1.25 0 0 1 1.362 0l.087.061 7.543 5.868c.939.73.423 2.236-.767 2.236H4.457c-1.19 0-1.706-1.506-.768-2.236l7.543-5.868.086-.061M5.186 9.25h13.628l-6.815-5.3-6.813 5.3m7.814 10 .077.004a.75.75 0 0 1 0 1.492L13 20.75H4a.75.75 0 0 1 0-1.5h9" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
